import { readonly, ref } from "vue"

const isInstallPromptSupported = ref(false)
const isIos = ref(false)
const isInstalled = ref(false)
const isLoading = ref(true)

let deferredPrompt: any = null
let initialized = false

function updateInstalledFlag() {
  isInstalled.value
    = window.matchMedia("(display-mode: standalone)").matches
    // iOS Safari "Add to Home Screen"
    // @ts-expect-error - standalone exists on iOS
      || window.navigator.standalone === true
}

// --- ATTACH EARLY so we never miss Chrome’s one-time event ---
if (typeof window !== "undefined") {
  // Capture BIP asap (before your app/router mounts)
  window.addEventListener("beforeinstallprompt", (e: any) => {
    e.preventDefault()
    deferredPrompt = e
    isInstallPromptSupported.value = true
  })

  // Keep install state fresh
  window.addEventListener("appinstalled", () => {
    isInstallPromptSupported.value = false
    updateInstalledFlag()
  })

  // Detect display-mode changes (Chrome desktop + Android)
  const mm = window.matchMedia("(display-mode: standalone)")
  if (mm && "addEventListener" in mm) {
    mm.addEventListener("change", updateInstalledFlag)
  }

  // iOS tab-switch quirk
  document.addEventListener("visibilitychange", updateInstalledFlag)
}

export function initPwaInstall() {
  if (initialized || typeof window === "undefined")
    return
  initialized = true

  const ua = window.navigator.userAgent.toLowerCase()
  isIos.value = /iphone|ipad|ipod/.test(ua)

  updateInstalledFlag()
  isLoading.value = false
}

export function usePwaInstall() {
  return {
    isInstallPromptSupported: readonly(isInstallPromptSupported),
    isIos: readonly(isIos),
    isInstalled: readonly(isInstalled),
    isLoading: readonly(isLoading),
    async promptInstall() {
      if (!deferredPrompt)
        return
      deferredPrompt.prompt()
      const { outcome } = await deferredPrompt.userChoice
      if (outcome === "accepted") {
        isInstallPromptSupported.value = false
      }
      deferredPrompt = null
    },
  }
}
